var map = {
	"./blue_economy.svg": "fedc",
	"./blue_economy_color.svg": "87c0",
	"./blue_economy_details.svg": "1a90",
	"./business_in_transition.svg": "65bd",
	"./business_in_transition_color.svg": "67ed",
	"./business_in_transition_details.svg": "cd2f",
	"./green_use_of_land.svg": "400c",
	"./green_use_of_land_color.svg": "5360",
	"./green_use_of_land_details.svg": "066b",
	"./social_economy.svg": "ac82",
	"./social_economy_color.svg": "ace7",
	"./social_economy_details.svg": "00cd",
	"./sustainable_energy.svg": "803e",
	"./sustainable_energy_color.svg": "f789",
	"./sustainable_energy_details.svg": "b1b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "00d4";